import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { gridNoMargin } from '@/css/resources/placeholders.css';
// import { resetLastChildMarginBottom } from '@/css/resources/placeholders.css';
import { breakpoints } from '@/css/resources/variables.css';

const getStyles = (styles) =>
	css({
		'.supt-section__content': cssObj({
			gridColumn: '7/13',

			[`@media (max-width: calc(${breakpoints.medium} - 1px))`]: {
				marginTop: '40px',
			},
		}),
	});

const getEditStyles = () => css({});

export { getStyles, getEditStyles };
